//import
    //Media
    import whatsAppLogo from '../media/whatsapp.png';


    
//rafce

const WhatsApp = () => {
  return (
    <div className="fixed">
      <a href="https://wa.link/yf2kkx" target="_blank" rel="noopener noreferrer">
        <img src={whatsAppLogo} alt="WhatsApp" />
      </a>
    </div>
  )
}

export default WhatsApp
